import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Notifications from 'react-notify-toast';
import { connect } from 'react-redux';
import containerActions from 'pages/Login/actions';

import Navbar from 'components/Navbar';
import Menu from 'components/Menu';
import ProgressBar from 'components/ProgressBar';
import Notification from 'components/Notification';
import NotificationLoadScreen from 'components/LoadScreen';
import Email from 'pages/Email';

import { URLS } from 'config';


import './styles.scss';
// const App = props => (
//   <div className="carsapp">
//     <Navbar />
//     <Menu />
//     <ProgressBar />
//     <div className="container">{props.children}</div>
//     <Notification />
//   </div>
// );

class App extends React.Component {
  componentWillReceiveProps(nextProps) {
    const deprecated = [URLS.LOGIN, URLS.PROFILE, URLS.RETURNED, URLS.PROFILECARS];

    if (deprecated.findIndex(el => el === nextProps.location.pathname) === -1) {
      if (nextProps.user && !Object.keys(nextProps.user).length) {
        localStorage.setItem('carsapp-route', nextProps.location.pathname);

        return;
      }
      const deprecatedProgress = [URLS.BASE, URLS.BUDGET,
        URLS.PHONE, URLS.NEEDCAR, URLS.RETURNED, URLS.LOGIN];

      if (nextProps.location.pathname !== this.props.location.pathname &&
        deprecatedProgress.findIndex(el => el === nextProps.location.pathname) === -1) {
        this.props.saveUserProgress(nextProps.location.pathname);
      }
    }
  }
  backHandl = () => {
    // eslint-disable-next-line
    this.props.history.goBack();
  }
  render() {
    return (
      <div className="carsapp">
        <Navbar backHandl={this.backHandl} />
        <Menu />
        <ProgressBar />
        <div className="container">{this.props.children}</div>
        <Notification />
        <Email />
        <Notifications />
        <NotificationLoadScreen />
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  saveUserProgress: PropTypes.func.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  user: state.user.user
});

export default connect(mapStateToProps, containerActions)(withRouter(App));



// WEBPACK FOOTER //
// ./src/App.js